import "./ContactExecutiveConsultation.module.css";
import Header from "@/reusable_sections/Header";
import IntroductoryCallToAction from "./sections/IntroductoryCallToAction";
import ExecutiveConsultationForm from "./sections/ExecutiveConsultationForm";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function ContactExecutiveConsultationPage() {
  return <div>
      <Header />
      <IntroductoryCallToAction />
      <ExecutiveConsultationForm />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}